export const messages = {
  en: {
    couponRule: {
      title: 'Coupon Rules',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 64 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      remarkMaxLength: 'Remark cannot exceed 512 characters',
      ruleIdRequired: 'Rule ID is required',
      addRule: 'Add Rule',
      editRule: 'Edit Rule',
      deleteConfirm: 'Delete Confirmation',
      deleteRulePrompt: 'Are you sure to delete this coupon rule?',
      selectRuleFirst: 'Please select a rule first',
      coupon: 'Coupon',
      fee: 'Fee'
    },
    couponRuleCpps: {
      id: 'ID',
      coupon: 'Coupon',
      couponPlaceholder: 'Please select coupon',
      couponRequired: 'Coupon is required',
      quantity: 'Quantity',
      quantityPlaceholder: 'Please enter quantity',
      quantityRequired: 'Quantity is required',
      quantityPattern: 'Quantity must be a positive integer',
      frequency: 'Frequency',
      frequencyPlaceholder: 'Please select frequency',
      frequencyRequired: 'Frequency is required',
      once: 'Once',
      monthly: 'Monthly',
      addCoupon: 'Add Coupon',
      editCoupon: 'Edit Coupon',
      deleteConfirm: 'Delete Confirmation',
      deletePrompt: 'Are you sure to delete this coupon?',
      idRequired: 'ID is required'
    },
    couponRuleFee: {
      id: 'ID',
      fee: 'Fee',
      feePlaceholder: 'Please select fee',
      feeRequired: 'Fee is required',
      payTime: 'Payment Time',
      payMonth: 'Payment Month',
      payMonthPlaceholder: 'Please enter payment month',
      payMonthRequired: 'Payment month is required',
      payStartTime: 'Start Time',
      payStartTimePlaceholder: 'Please select start time',
      payStartTimeRequired: 'Start time is required',
      payEndTime: 'End Time',
      payEndTimePlaceholder: 'Please select end time',
      payEndTimeRequired: 'End time is required',
      addFee: 'Add Fee',
      deleteConfirm: 'Delete Confirmation',
      deletePrompt: 'Are you sure to delete this fee rule?'
    }
  },
  zh: {
    couponRule: {
      title: '优惠券规则',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过64个字符',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      remarkMaxLength: '备注不能超过512个字符',
      ruleIdRequired: '规则ID不能为空',
      addRule: '添加规则',
      editRule: '编辑规则',
      deleteConfirm: '删除确认',
      deleteRulePrompt: '确定要删除此优惠券规则吗？',
      selectRuleFirst: '请先选择规则',
      coupon: '优惠券',
      fee: '缴费赠送'
    },
    couponRuleCpps: {
      id: '编号',
      coupon: '优惠券',
      couponPlaceholder: '请选择优惠券',
      couponRequired: '优惠券不能为空',
      quantity: '数量',
      quantityPlaceholder: '请输入数量',
      quantityRequired: '数量不能为空',
      quantityPattern: '数量必须为正整数',
      frequency: '频率',
      frequencyPlaceholder: '请选择频率',
      frequencyRequired: '频率不能为空',
      once: '赠送一次',
      monthly: '每月赠送',
      addCoupon: '添加优惠券',
      editCoupon: '编辑优惠券',
      deleteConfirm: '删除确认',
      deletePrompt: '确定要删除此优惠券吗？',
      idRequired: 'ID不能为空'
    },
    couponRuleFee: {
      id: '编号',
      fee: '费用',
      feePlaceholder: '请选择费用',
      feeRequired: '费用不能为空',
      payTime: '缴费时间',
      payMonth: '缴费月',
      payMonthPlaceholder: '请输入缴费月',
      payMonthRequired: '缴费月不能为空',
      payStartTime: '开始时间',
      payStartTimePlaceholder: '请选择开始时间',
      payStartTimeRequired: '开始时间不能为空',
      payEndTime: '结束时间',
      payEndTimePlaceholder: '请选择结束时间',
      payEndTimeRequired: '结束时间不能为空',
      addFee: '添加缴费赠送',
      deleteConfirm: '删除确认',
deletePrompt: '確定要刪除此繳費規則嗎？'
    }
  },
  'zh-TW': {
    couponRule: {
      title: '優惠券規則',
      ruleName: '規則名稱',
      ruleNamePlaceholder: '請輸入規則名稱',
      ruleNameRequired: '規則名稱不能為空',
      ruleNameMaxLength: '規則名稱不能超過64個字符',
      remark: '備註',
      remarkPlaceholder: '請輸入備註',
      remarkMaxLength: '備註不能超過512個字符',
      ruleIdRequired: '規則ID不能為空',
      addRule: '添加規則',
      editRule: '編輯規則',
      deleteConfirm: '刪除確認',
      deleteRulePrompt: '確定要刪除此優惠券規則嗎？',
      selectRuleFirst: '請先選擇規則',
      coupon: '優惠券',
      fee: '繳費贈送'
    },
    couponRuleCpps: {
      id: '編號',
      coupon: '優惠券',
      couponPlaceholder: '請選擇優惠券',
      couponRequired: '優惠券不能為空',
      quantity: '數量',
      quantityPlaceholder: '請輸入數量',
      quantityRequired: '數量不能為空',
      quantityPattern: '數量必須為正整數',
      frequency: '頻率',
      frequencyPlaceholder: '請選擇頻率',
      frequencyRequired: '頻率不能為空',
      once: '贈送一次',
      monthly: '每月贈送',
      addCoupon: '添加優惠券',
      editCoupon: '編輯優惠券',
      deleteConfirm: '刪除確認',
      deletePrompt: '確定要刪除此優惠券嗎？',
      idRequired: 'ID不能為空'
    },
    couponRuleFee: {
      id: '編號',
      fee: '費用',
      feePlaceholder: '請選擇費用',
      feeRequired: '費用不能為空',
      payTime: '繳費時間',
      payMonth: '繳費月',
      payMonthPlaceholder: '請輸入繳費月',
      payMonthRequired: '繳費月不能為空',
      payStartTime: '開始時間',
      payStartTimePlaceholder: '請選擇開始時間',
      payStartTimeRequired: '開始時間不能為空',
      payEndTime: '結束時間',
      payEndTimePlaceholder: '請選擇結束時間',
      payEndTimeRequired: '結束時間不能為空',
      addFee: '添加繳費贈送',
      deleteConfirm: '刪除確認',
      deletePrompt: '確定要刪除此繳費規則嗎？'
    }
  }
}